<template>
  <div class="full-area padded vertically-centered desktop-wrapperx">
    <h2>Procesando...</h2>
    <div class="action-wrapper">
      <el-row class="transition-visibility" :class="{ 'invisible': !spinner }">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </el-row>
      <el-row class="transition-visibility" :class="{ 'invisible': !error }">
        <p class="error-wrapper">Ocurrió un error: <br>{{errMessage}}</p>
        <el-button
          class="button-wrapper"
          type="danger"
          round @click="sendAnswers()"
        >Procesar de nuevo</el-button>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Submit',

  data () {
    return {
      error: false,
      errMessage: '',
      spinner: false
    }
  },

  mounted () {
    if (this.$store.state.survey.status !== 'submit') {
      this.$router.push('/')
    } else {
      this.sendAnswers()

      // calculate weightedVector
      const responses = this.$store.state.responses
      var vector = [0, 0, 0, 0]
      var weightedMin = [0, 0, 0, 0]
      var weightedMax = [0, 0, 0, 0]
      console.log(responses)
      responses.forEach(response => {
        if (!response.weighted || response.weighted.length === 0) {
          return
        }
        response.weighted.forEach((score, index) => {
          if (!isNaN(score)) {
            vector[index] = parseInt(vector[index], 10) + parseInt(score, 10)
          }
        })
        response.weightedMax.forEach((thisDimension, index) => {
          if (!isNaN(thisDimension)) {
            weightedMax[index] = parseInt(weightedMax[index], 10) + parseInt(thisDimension, 10)
          }
        })
        response.weightedMin.forEach((thisDimension, index) => {
          if (!isNaN(thisDimension)) {
            weightedMin[index] = parseInt(weightedMin[index], 10) + parseInt(thisDimension, 10)
          }
        })
      })

      var newVector = []
      vector.forEach((dimension, index) => {
        newVector.push(Math.floor(100 * (dimension / (weightedMax[index] - weightedMin[index]) - weightedMin[index] / (weightedMax[index] - weightedMin[index])), 1))
      })
      this.$store.commit('STORE_TEST_RESULT', { weightedTestResults: newVector })
    }
  },

  methods: {
    sendAnswers () {
      this.error = false
      this.spinner = true
      return this.$store.dispatch('SUBMIT_FORM')
        .then(() => {
          this.spinner = false
          this.$store.dispatch('THANK_YOU')
          this.$router.push({ name: 'results', params: { sid: this.$route.params.sid } })
        })
        .catch(err => {
          this.spinner = false
          this.error = true
          this.errMessage = err
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.transition-visibility {
  transition: opacity 0.2s ease-in-out;
}
.invisible {
  opacity: 0;
}
.action-wrapper {
  min-height: 120px;
  position: relative;

  .el-row {
    position: absolute;
    margin: 0 auto;
    width: 100%;
  }
}
</style>
